export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M0 20h24v4H0zm5.5-3L11 3h2l5.49 14h-2.25l-1.12-3H8.87l-1.12 3zM12 5.67 9.62 12h4.76z\"/>"
};